let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1D35j")).then(() => parcelRequire('bDbwM'));